import { Link } from 'react-router-dom';
import { TableHeaderButtonProps } from './types';
import { OutlinedSecondaryButton } from 'components/buttons/OutlinedSecondaryButton';

const TableHeaderButton: React.FunctionComponent<TableHeaderButtonProps> = (props) => {
  const { title, component, disabled, className, id, buttonProps, children } = props;

  const baseProps = {
    disabled,
    className,
    id,
    ...buttonProps?.props,
    children: children ?? title,
  };

  if ('to' in props) {
    return (
      <OutlinedSecondaryButton
        component={component ?? Link}
        to={props.to}
        target={props.target}
        {...baseProps}
      />
    );
  }

  return <OutlinedSecondaryButton onClick={props.onClick} {...baseProps} />;
};

export default TableHeaderButton;
